/**
 * Dental Procedure Consent Form — Stage 1.
 */
import { Text } from '@react-pdf/renderer'

import { SNOOTS_BG } from '@snootsvet/shared'

import {
  ANAESTHESIA_RISK_CLAUSE,
  DENTAL_S1_EXTENT_CLAUSE,
  DISCHARGE_TIME_CLAUSE,
  EMERGENCY_AUTH_CLAUSE,
  IV_FLUIDS_CLAUSE,
} from '@/frontend/features/printing/documents/consent/clauses'
import { buildPreOpConsentForm } from '@/frontend/features/printing/documents/consent/consent-template.form'

const consentText = (name: string) =>
  `I am the owner or authorised agent for the owner of ${name}. I give my consent for Snoots to perform a general anaesthetic, scale & polish and dental x-rays.`

export const dentalConsentStage1 = buildPreOpConsentForm({
  id: 'dental-consent-stage1',
  label: 'Dental Consent — Stage 1',
  title: 'DENTAL PROCEDURE CONSENT FORM – STAGE 1',
  // Dental procedures are carried out at the Bounds Green clinic.
  clinic: SNOOTS_BG,
  renderConsentPreview: ({ patientName }) => <p>{consentText(patientName)}</p>,
  renderConsentPrint: ({ patientName }) => (
    <Text style={{ fontSize: 10 }}>{consentText(patientName)}</Text>
  ),
  clauses: [
    DENTAL_S1_EXTENT_CLAUSE,
    ANAESTHESIA_RISK_CLAUSE,
    EMERGENCY_AUTH_CLAUSE,
    IV_FLUIDS_CLAUSE,
    DISCHARGE_TIME_CLAUSE,
  ],
})
